import { useCallback, useRef } from 'react';

/**
 * Coalesces concurrent async calls into one in-flight promise until it settles.
 * Use for submit handlers that must not hit the same API twice (OTP verify, login).
 */
export function useSingleFlight() {
  const inFlightRef = useRef<Promise<unknown> | null>(null);

  const runSingleFlight = useCallback(<T,>(fn: () => Promise<T>): Promise<T> => {
    if (inFlightRef.current) {
      return inFlightRef.current as Promise<T>;
    }
    const promise = fn().finally(() => {
      inFlightRef.current = null;
    });
    inFlightRef.current = promise;
    return promise;
  }, []);

  return runSingleFlight;
}
